import { gql } from "@apollo/client";
import { ContactPersonFields } from "../fragments/contactPersonFields";

// Assign picker: the node only accepts contacts of its own client, so callers
// filter by the node owner's clientId.
export const ContactPersonPickerList = gql`
    query ContactPersonPickerList($filter: ContactPersonListFilter, $search: SearchInput, $pagination: Pagination) {
        contactPersonList(filter: $filter, search: $search) {
            total
            contactPersons(pagination: $pagination, sort: {name: asc}) {
                ...ContactPersonFields
            }
        }
    }
    ${ContactPersonFields}
`;
